<template>
  <div 
    class="cell border"
    :style="style"
  >
    <slot />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  props: {
    width: { type: String, default: '100%' },
  },

  computed: {
    style() {
      return `width: ${this.width};`
    },
  },
})
</script>

<style lang="scss" scoped>
@import '../../scss/expinet.scss';
@import '@gecko-akh/shared-styles/src/styles/AOS.vars.scss';

.cell {
  display: inline-block;
  vertical-align: top;
  white-space: normal;
}
</style>
